import { useEffect, useLayoutEffect, useRef } from 'react';
import styled from 'styled-components';
import reset from 'styled-reset';
import { createGlobalStyle } from 'styled-components';
import { Outlet, useLocation, ScrollRestoration } from 'react-router-dom';
import Header from './components/Header';
import Scrollbar from 'smooth-scrollbar';
import OverscrollPlugin from 'smooth-scrollbar/plugins/overscroll';
import { ThemeProvider } from '@mui/material/styles';
import customTheme from './utils/theme';

Scrollbar.use(OverscrollPlugin);

const GlobalStyle = createGlobalStyle`
  ${reset}

  body{
    font-family: 'Lora','Noto Sans KR', 'Roboto', sans-serif;
    color: #0D0907;
  }

  a{
    text-decoration: none;
    color: #0D0907;
  }
`;

const ScrollableContent = styled.div`
	height: 100vh;
`;

const OutletWrapper = styled.div`
	position: relative;
	top: 75px; // Header의 높이
`;

const App = () => {
	const scrollContainerRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		if (scrollContainerRef.current) {
			Scrollbar.init(scrollContainerRef.current, {
				plugins: {
					overscroll: {
						effect: 'bounce',
						damping: 0.1,
						maxOverscroll: 140,
					},
				},
			});
		}
	}, []);

	const { pathname } = useLocation();
	useLayoutEffect(() => {
		if (scrollContainerRef && scrollContainerRef.current) {
			const scrollBar = Scrollbar.get(scrollContainerRef.current);
			if (scrollBar) {
				scrollBar.scrollTo(0, 0, 0);
			}
		}
	}, [pathname]);

	return (
		<>
			<ThemeProvider theme={customTheme}>
				<GlobalStyle />
				<Header />
				<ScrollableContent ref={scrollContainerRef}>
					<OutletWrapper>
						<Outlet />
					</OutletWrapper>
				</ScrollableContent>
				<ScrollRestoration />
			</ThemeProvider>
		</>
	);
};

export default App;
